import useAuth from '@arelia-hooks/useAuth';

export default function AuthorizeRoute({ element, ...rest }: any) {
  const user = useAuth();

  if (!user) {
    return (<div></div>);
  }


  return element;
}
